import { useEffect } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Type for the config
type ScrollCircleConfig = {
  targetClass: string;
  triggerClass: string;
  x?: number;
  y?: number;
  start?: string;
  end?: string;
  duration?: number;
};

export const useScrollDownCircle = (configs: ScrollCircleConfig[]) => {
  useEffect(() => {
    const animations: ScrollTrigger[] = [];

    configs.forEach((config) => {
      const {
        targetClass,
        triggerClass,
        x = 0,
        y = 0,
        start = 'top top',
        end = '30% top',
        duration = 1.5,
      } = config;

      const targets = document.querySelectorAll(`.${targetClass}`);
      if (targets.length) {
        const tween = gsap.to(`.${targetClass}`, {
          x,
          y,
          autoAlpha: 0,
          ease: 'none',
          duration, // ✅ moved here
          scrollTrigger: {
            trigger: `.${triggerClass}`,
            start,
            end,
            scrub: true,
            markers: false,
          },
        });

        animations.push(tween.scrollTrigger!);
      }
    });

    return () => {
      animations.forEach(trigger => trigger.kill(true));
    };
  }, [configs]);
};
